import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Profile from './Profile';
import PageContentError from '../UI/PageContentError';
import PropTypes from 'prop-types';

const ProfileRoute = ({ match }) => {
  const { path } = match;
  return (
    <Switch>
      <Route exact path={path} component={Profile} />
      <Route path='*' component={PageContentError} />
    </Switch>
  );
};

ProfileRoute.propTypes = {
  match: PropTypes.object.isRequired,
  path: PropTypes.string
};

export default ProfileRoute;
